import axios, {Axios} from "axios"
import {NAME_HOST} from "../../Utils/NAME_HOST";

export const API_URL = "https://snake.money/bonusAPI";
const $api = axios.create({
    withCredentials: true,// куки цепляются автоматический
    baseURL:API_URL
})
export default $api